import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'

import { BankIconImg } from '../../../components/BankIconImg'
import type { IBlockPayloadBankAccounts } from '../../../types'

interface Props {
  payload: IBlockPayloadBankAccounts
}

export const BankAccountsRenderer: React.FC<Props> = ({ payload }) => {
  const accounts = payload?.accounts ?? []
  const title = payload?.title?.trim()

  if (accounts.length === 0) {
    return (
      <Box sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
        <Typography variant="body2">ยังไม่มีบัญชีธนาคารในบล็อกนี้</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

      {accounts.map((row, idx) => (
        <Paper key={idx} variant="outlined" sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
            {row.bankCode ? <BankIconImg code={row.bankCode} size={28} /> : null}
            <Typography variant="subtitle2" fontWeight={600}>
              {row.bankName || '—'}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            ชื่อบัญชี: {row.accountName || '—'}
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'ui-monospace, monospace', mt: 0.5 }}>
            เลขบัญชี: {row.accountNumber || '—'}
          </Typography>
          {row.branch?.trim() && (
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              สาขา {row.branch}
            </Typography>
          )}
        </Paper>
      ))}
    </Box>
  )
}
